import React from "react";
import SwitchBase, { type SwitchProps } from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";

const Switch = SwitchBase as React.ElementType;

type MuiSwitchComponentProps = {
  label?: React.ReactNode;
  isSwitchChecked?: boolean;
  handleSwitchChange?: SwitchProps["onChange"];
  initialDisabled?: boolean;
};

function MuiSwitchComponent({
  label = "",
  isSwitchChecked,
  handleSwitchChange,
  initialDisabled = false,
}: MuiSwitchComponentProps) {
  return (
    <FormGroup aria-label="position" row>
      <FormControlLabel
        value="top"
        control={
          <Switch
            value="top"
            checked={isSwitchChecked}
            onChange={handleSwitchChange}
            label={label}
          />
        }
        labelPlacement="top"
        label={label}
        className="postcard-switch align-items-start"
        disabled={initialDisabled}
      />
    </FormGroup>
  );
}

export default MuiSwitchComponent;
